const cardResumen = [
  {
    label: 'general_information',
    data: [
      // {
      //   //   value: 'NoAduana',
      //   //   key: '',
      //   //   label: 'Número de Do Aduana IMPO/EXPO:',
      //   //   bold: false,
      //   //   info: false
      //   // },
      //   // {
      //   //   value: 'RefForwarder',
      //   //   key: '',
      //   //   primary: true,
      //   //   label: 'Número de Do Referencia Forwarder',
      //   //   bold: false,
      //   //   info: false
      //   // },
      //   // {
      //   value: '',
      //   key: 'ContainerNo',
      //   label: 'Numero de Contenedor',
      //   bold: false
      // },
      // {
      //   value: '',
      //   key: 'Status',
      //   label: 'Estatus',
      //   bold: false,
      //   info: false,
      //   // link:'/shipmentsDetal/',
      //   // idlink:'EmbarqueId',
      //   value2: ''
      // },
      {
        value: '',
        key: 'ShipmentNumber',
        link: '/shipments-details/',
        idlink: 'ShipmentId',
        label: 'shipment_num',
        bold: false,
        info: false
      },
      {
        value: '',
        key: 'ContainerType',
        label: 'container_type',
        bold: false,
        info: false
      },
      {
        value: '',
        key: 'Seal',
        label: 'seal',
        bold: false,
        info: false
      },
      {
        value: '',
        key: 'Temperature',
        label: 'required_temperature',
        bold: false
      },
      {
        value: '',
        key: 'SpecialInstructions',
        label: 'special_instruccions',
        primary: false,
        otro: true,
      }
    ]
  },
  {
    label: 'route',
    data: [
      {
        value: '',
        key: 'POL',
        label: 'origin',
        bold: false
      },
      {
        value: '',
        key: 'POD',
        label: 'destination',
        bold: false
      },
      {
        value: '',
        key: 'Route',
        label: 'route',
        bold: false
      },
      {
        value: '',
        key: 'PickupLocation',
        label: 'pickup_address',
        bold: false
      },
      {
        value: '',
        key: 'DeliveryLocation',
        label: 'delivery_address',
        bold: false
      },
      {
        value: '',
        key: 'ETD',
        label: 'etd',
        bold: false
      },
      {
        value: '',
        key: 'ETA',
        label: 'eta',
        bold: false
      },
      // {
      //   value: '',
      //   key: 'appointmentDate',
      //   label: 'Cita en puerto',
      //   bold: false
      // },
      {
        value: '',
        key: 'EmptyContainerPickup',
        label: 'empty_container_recollection',
        bold: false
      },
      {
        value: '',
        key: 'LinePickupDate',
        label: 'pickup_in_origin',
        bold: false
      },
      {
        value: '',
        key: 'InGateAtOrigin',
        label: 'gate_in_origin',
        bold: false
      },
      {
        value: '',
        key: 'ATD',
        label: 'ATD',
        bold: false
      },
      {
        value: '',
        key: 'ATA',
        label: 'ATA',
        bold: false
      },
      {
        value: '',
        key: 'ContainerDischargeAtDestination',
        label: 'unloading_container_dest',
        bold: false
      },

      


      {
        value: '',
        key: 'OutOfGateDate',
        label: 'out_of_gate',
        bold: false
      },
      
      {
        value: '',
        key: 'LineDeliveryDate',
        label: 'delivery_at_destination',
        bold: false
      },
      // {
      //   value: '',
      //   key: 'MaxEmptyReturnDate',
      //   label: 'Fecha máxima de retorno',
      //   bold: false
      // },
      // {
      //   value: '',
      //   key: 'LastFreeDayDate',
      //   label: 'Fecha última de almacenamiento gratuito',
      //   bold: false
      // },
      {
        value: '',
        key: 'ActualEmptyReturnDate',
        label: 'actual_empty_return',
        bold: false
      }
    ]
  },
  {
    label: "cargo",
    data: [
      {
        value: '',
        key: 'Packages',
        label: 'total_packages',
        primary: false,
        otro: false
      },
      {
        value: '',
        key: 'Pieces',
        label: 'total_píeces',
        primary: false,
        otro: false
      }, {
        value: '',
        key: 'Measure',
        label: 'package_type',
        primary: false,
        otro: false
      },  {
        value: '',
        key: 'UOMVolumeDescription',
        label: 'total_volume',
        primary: false,
        otro: false
      },
      {
        value: '',
        key: 'UOMDimensionsDescription',
        label: 'dimensions',
        primary: false,
        otro: false
      },
      {
        value: '',
        key: 'UOMWeightDescription',
        label: 'chargable_weight',
        primary: false,
        otro: false,
        format: 'weight'
      },
      {
        value: '',
        key: 'UOMGrossWeightDescription',
        label: 'gross_weight',
        primary: false,
        otro: false,
        format: 'weight'
      },
      {
        value: '',
        key: 'GoodsDescription',
        label: 'goods_description',
        primary: false,
        otro: true,
      }
      , {
        value: '',
        key: 'DeclaredValue',
        label: 'declared_value',
        primary: false,
        otro: true,
      }
      , {
        value: '',
        key: 'DeclaredValueCurrency',
        label: 'currency',
        primary: false,
        otro: true,
      }, , {
        value: '',
        key: 'DGR',
        label: 'dgr',
        primary: false,
        otro: true,
      },
    ]
  }]

export default cardResumen